import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../../ReducerRegister";
import EditService from "../../../../../services/screens/admin/partner/user/EditService";
import { ActionTypes } from "../../../../actionTypes/screens/admin/partner/user/EditActionTypes";
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.partner.user.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    savePartnerUserAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_PARTNER_USER_ASYNC, vo });

            EditService.savePartnerUser(
                vo,
                response => {
                    dispatch(Actions.savePartnerUserSuccess(response));
                },
                error => {
                    dispatch(Actions.savePartnerUserFailure(error));
                }
            );
        };
    },

    savePartnerUserSuccess: data => ({
        type: ActionTypes.SAVE_PARTNER_USER_SUCCESS,
        parentType: ActionTypes.SAVE_PARTNER_USER_ASYNC,
        data
    }),

    savePartnerUserFailure: error => ({
        type: ActionTypes.SAVE_PARTNER_USER_FAILURE,
        parentType: ActionTypes.SAVE_PARTNER_USER_ASYNC,
        error
    }),

    createPartnerUser: (partnerId) => ({
        type: ActionTypes.CREATE_PARTNER_USER,
        partnerId
    }),

    updateIsCreated: () => ({
        type: ActionTypes.UPDATE_IS_CREATED
    }),

    createPartnerUserAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.CREATE_PARTNER_USER_ASYNC, vo });

            EditService.createPartnerUser(
                vo,
                response => {
                    dispatch(Actions.createPartnerUserSuccess(response));
                },
                error => {
                    dispatch(Actions.createPartnerUserFailure(error));
                }
            );
        };
    },

    createPartnerUserSuccess: data => ({
        type: ActionTypes.CREATE_PARTNER_USER_SUCCESS,
        parentType: ActionTypes.CREATE_PARTNER_USER_ASYNC,
        data
    }),

    createPartnerUserFailure: error => ({
        type: ActionTypes.CREATE_PARTNER_USER_FAILURE,
        parentType: ActionTypes.CREATE_PARTNER_USER_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    partnerUser: null,
    isCreated: false
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, partnerUser: data.partnerUser };
};

const createPartnerUserReducer = (state, { partnerId }) => {
    return { ...state, partnerUser: { partnerId } };
};

const updateIsCreatedReducer = (state) => {
    return { ...state, isCreated: true };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_PARTNER_USER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_PARTNER_USER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_PARTNER_USER_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_PARTNER_USER]: createPartnerUserReducer,
    [ActionTypes.UPDATE_IS_CREATED]: updateIsCreatedReducer,
    [ActionTypes.CREATE_PARTNER_USER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.CREATE_PARTNER_USER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.CREATE_PARTNER_USER_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
